module.exports = __webpack_public_path__ + "img/12_002.4de26ddc.webp";